var map = {
	"./google-laurel-da-DK.svg": 72946,
	"./google-laurel-de-DE.svg": 92112,
	"./google-laurel-en-GB.svg": 76402,
	"./google-laurel-en-US.svg": 38233,
	"./google-laurel-es-ES.svg": 85962,
	"./google-laurel-es-MX.svg": 27945,
	"./google-laurel-fr-FR.svg": 15498,
	"./google-laurel-it-IT.svg": 38824,
	"./google-laurel-nb-NO.svg": 84071,
	"./google-laurel-nl-NL.svg": 37734,
	"./google-laurel-pl-PL.svg": 94558,
	"./google-laurel-pt-BR.svg": 69282,
	"./google-laurel-pt-PT.svg": 27902,
	"./google-laurel-sv-SE.svg": 11259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;